import { Checkbox, Col, Divider, Form, Radio, Row } from 'antd'

import {
  IntestinalMotilityAssessment,
  LiverConsistencyAssessment,
  SpleenConsistencyAssessment
} from 'src/api/requests'
import { Text } from 'src/components'
import { useLocales } from 'src/locales'

import { useStyles } from '../styles'

type Props = {
  isPrimary: boolean
}

export const ConsultationFormAbdominalSection = ({ isPrimary }: Props) => {
  const { t } = useLocales()

  const { styles } = useStyles()

  const order = isPrimary ? 25 : 20

  return (
    <Col span={24}>
      <Text>
        {order}.{' '}
        {t('consultation_form.abdominal_gastrointestinal_assessment.title')}
      </Text>

      <Row gutter={[16, 16]} className="mt-16 ml-16">
        <Col span={24}>
          <Text>
            {order}.1{' '}
            {t('consultation_form.abdominal_gastrointestinal_assessment.liver')}
          </Text>
        </Col>

        <Col span={6}>
          <Form.Item
            name={[
              'form',
              'physicalExaminationSection',
              'abdominalGastrointestinalAssessment',
              'liver',
              'isPalpable'
            ]}
            valuePropName="checked"
          >
            <Checkbox>
              {t(
                'consultation_form.abdominal_gastrointestinal_assessment.isPalpable'
              )}
            </Checkbox>
          </Form.Item>
        </Col>

        <Col span={6}>
          <Form.Item
            name={[
              'form',
              'physicalExaminationSection',
              'abdominalGastrointestinalAssessment',
              'liver',
              'isNotPalpable'
            ]}
            valuePropName="checked"
          >
            <Checkbox>
              {t(
                'consultation_form.abdominal_gastrointestinal_assessment.isNotPalpable'
              )}
            </Checkbox>
          </Form.Item>
        </Col>

        <Col span={6}>
          <Form.Item
            name={[
              'form',
              'physicalExaminationSection',
              'abdominalGastrointestinalAssessment',
              'liver',
              'isPainful'
            ]}
            valuePropName="checked"
          >
            <Checkbox>
              {t(
                'consultation_form.abdominal_gastrointestinal_assessment.isPainful'
              )}
            </Checkbox>
          </Form.Item>
        </Col>

        <Col span={6}>
          <Form.Item
            name={[
              'form',
              'physicalExaminationSection',
              'abdominalGastrointestinalAssessment',
              'liver',
              'isNotPainful'
            ]}
            valuePropName="checked"
          >
            <Checkbox>
              {t(
                'consultation_form.abdominal_gastrointestinal_assessment.isNotPainful'
              )}
            </Checkbox>
          </Form.Item>
        </Col>

        <Col span={24} className="ml-16">
          <Form.Item
            className="ml-16"
            name={[
              'form',
              'physicalExaminationSection',
              'abdominalGastrointestinalAssessment',
              'liver',
              'consistency'
            ]}
            label={`${order}.1.1 ${t('consultation_form.abdominal_gastrointestinal_assessment.consistency')}`}
          >
            <Radio.Group>
              {Object.values(LiverConsistencyAssessment).map((value) => (
                <Radio value={value} key={value}>
                  {t(
                    `consultation_form.abdominal_gastrointestinal_assessment.${value}`
                  )}
                </Radio>
              ))}
            </Radio.Group>
          </Form.Item>
        </Col>

        <Divider className={styles.divider} />

        <Col span={24}>
          <Text>
            {order}.2{' '}
            {t(
              'consultation_form.abdominal_gastrointestinal_assessment.spleen'
            )}
          </Text>
        </Col>

        <Col span={6}>
          <Form.Item
            name={[
              'form',
              'physicalExaminationSection',
              'abdominalGastrointestinalAssessment',
              'spleen',
              'isPalpable'
            ]}
            valuePropName="checked"
          >
            <Checkbox>
              {t(
                'consultation_form.abdominal_gastrointestinal_assessment.isPalpable'
              )}
            </Checkbox>
          </Form.Item>
        </Col>

        <Col span={6}>
          <Form.Item
            name={[
              'form',
              'physicalExaminationSection',
              'abdominalGastrointestinalAssessment',
              'spleen',
              'isNotPalpable'
            ]}
            valuePropName="checked"
          >
            <Checkbox>
              {t(
                'consultation_form.abdominal_gastrointestinal_assessment.isNotPalpable'
              )}
            </Checkbox>
          </Form.Item>
        </Col>

        <Col span={6}>
          <Form.Item
            name={[
              'form',
              'physicalExaminationSection',
              'abdominalGastrointestinalAssessment',
              'spleen',
              'isPainful'
            ]}
            valuePropName="checked"
          >
            <Checkbox>
              {t(
                'consultation_form.abdominal_gastrointestinal_assessment.isPainful'
              )}
            </Checkbox>
          </Form.Item>
        </Col>

        <Col span={6}>
          <Form.Item
            name={[
              'form',
              'physicalExaminationSection',
              'abdominalGastrointestinalAssessment',
              'spleen',
              'isNotPainful'
            ]}
            valuePropName="checked"
          >
            <Checkbox>
              {t(
                'consultation_form.abdominal_gastrointestinal_assessment.isNotPainful'
              )}
            </Checkbox>
          </Form.Item>
        </Col>

        <Col span={24} className="ml-16">
          <Form.Item
            className="ml-16"
            name={[
              'form',
              'physicalExaminationSection',
              'abdominalGastrointestinalAssessment',
              'spleen',
              'consistency'
            ]}
            label={`${order}.2.1 ${t('consultation_form.abdominal_gastrointestinal_assessment.consistency')}`}
          >
            <Radio.Group>
              {Object.values(SpleenConsistencyAssessment).map((value) => (
                <Radio value={value} key={value}>
                  {t(
                    `consultation_form.abdominal_gastrointestinal_assessment.${value}`
                  )}
                </Radio>
              ))}
            </Radio.Group>
          </Form.Item>
        </Col>

        <Divider className={styles.divider} />

        <Col span={24}>
          <Form.Item
            name={[
              'form',
              'physicalExaminationSection',
              'abdominalGastrointestinalAssessment',
              'intestinalMotility'
            ]}
            label={`${order}.3 ${t('consultation_form.abdominal_gastrointestinal_assessment.intestinalMotility')}`}
          >
            <Radio.Group>
              {Object.values(IntestinalMotilityAssessment).map((value) => (
                <Radio value={value} key={value}>
                  {t(
                    `consultation_form.abdominal_gastrointestinal_assessment.${value}`
                  )}
                </Radio>
              ))}
            </Radio.Group>
          </Form.Item>
        </Col>

        <Divider className={styles.divider} />

        <Col span={24}>
          <Text>
            {order}.4{' '}
            {t(
              'consultation_form.abdominal_gastrointestinal_assessment.abdominalSensitivity'
            )}
          </Text>
        </Col>

        <Col span={6}>
          <Form.Item
            name={[
              'form',
              'physicalExaminationSection',
              'abdominalGastrointestinalAssessment',
              'abdominalSensitivity',
              'isSensitive'
            ]}
            valuePropName="checked"
          >
            <Checkbox>
              {t(
                'consultation_form.abdominal_gastrointestinal_assessment.isSensitive'
              )}
            </Checkbox>
          </Form.Item>
        </Col>

        <Col span={6}>
          <Form.Item
            name={[
              'form',
              'physicalExaminationSection',
              'abdominalGastrointestinalAssessment',
              'abdominalSensitivity',
              'isInsensitive'
            ]}
            valuePropName="checked"
          >
            <Checkbox>
              {t(
                'consultation_form.abdominal_gastrointestinal_assessment.isInsensitive'
              )}
            </Checkbox>
          </Form.Item>
        </Col>

        <Col span={6}>
          <Form.Item
            name={[
              'form',
              'physicalExaminationSection',
              'abdominalGastrointestinalAssessment',
              'abdominalSensitivity',
              'isPainful'
            ]}
            valuePropName="checked"
          >
            <Checkbox>
              {t(
                'consultation_form.abdominal_gastrointestinal_assessment.isPainful'
              )}
            </Checkbox>
          </Form.Item>
        </Col>

        <Col span={6}>
          <Form.Item
            name={[
              'form',
              'physicalExaminationSection',
              'abdominalGastrointestinalAssessment',
              'abdominalSensitivity',
              'hasMuscleRigidity'
            ]}
            valuePropName="checked"
          >
            <Checkbox>
              {t(
                'consultation_form.abdominal_gastrointestinal_assessment.hasMuscleRigidity'
              )}
            </Checkbox>
          </Form.Item>
        </Col>

        <Divider className={styles.divider} />

        <Col span={24}>
          <Text>
            {order}.5{' '}
            {t(
              'consultation_form.abdominal_gastrointestinal_assessment.digestiveSigns'
            )}
          </Text>
        </Col>

        <Col span={6}>
          <Form.Item
            name={[
              'form',
              'physicalExaminationSection',
              'abdominalGastrointestinalAssessment',
              'digestiveSigns',
              'hasNausea'
            ]}
            valuePropName="checked"
          >
            <Checkbox>
              {t(
                'consultation_form.abdominal_gastrointestinal_assessment.hasNausea'
              )}
            </Checkbox>
          </Form.Item>
        </Col>

        <Col span={6}>
          <Form.Item
            name={[
              'form',
              'physicalExaminationSection',
              'abdominalGastrointestinalAssessment',
              'digestiveSigns',
              'hasVomiting'
            ]}
            valuePropName="checked"
          >
            <Checkbox>
              {t(
                'consultation_form.abdominal_gastrointestinal_assessment.hasVomiting'
              )}
            </Checkbox>
          </Form.Item>
        </Col>

        <Col span={6}>
          <Form.Item
            name={[
              'form',
              'physicalExaminationSection',
              'abdominalGastrointestinalAssessment',
              'digestiveSigns',
              'hasDysphagia'
            ]}
            valuePropName="checked"
          >
            <Checkbox>
              {t(
                'consultation_form.abdominal_gastrointestinal_assessment.hasDysphagia'
              )}
            </Checkbox>
          </Form.Item>
        </Col>
      </Row>
    </Col>
  )
}
